(function () {
  'use strict';

  if (window.__ccgFilterControllerV3) return;
  window.__ccgFilterControllerV3 = true;

  function qs(root, selector) { return root ? root.querySelector(selector) : null; }
  function qsa(root, selector) { return root ? Array.prototype.slice.call(root.querySelectorAll(selector)) : []; }
  function wrapperFor(el) { return el && el.closest ? el.closest('.ccg') : null; }

  // ---------- Price presets (multi-select, OR) ----------

  function allPresets(wrapper) { return qsa(wrapper, '[data-ccg-price-preset]'); }
  function checkedPresets(wrapper) { return qsa(wrapper, '[data-ccg-price-preset]:checked'); }

  // True when the checked presets are neighbours in the list (so one native range covers them exactly).
  function isContiguous(wrapper) {
    var all = allPresets(wrapper);
    var idx = all.map(function (p, i) { return p.checked ? i : -1; }).filter(function (i) { return i >= 0; });
    if (idx.length <= 1) return true;
    return idx[idx.length - 1] - idx[0] === idx.length - 1;
  }

  function presetRange(p) {
    var min = p.dataset.min === '' || p.dataset.min == null ? 0 : parseFloat(p.dataset.min);
    var max = p.dataset.max === '' || p.dataset.max == null ? Infinity : parseFloat(p.dataset.max);
    return { min: min, max: max };
  }

  function inRanges(price, ranges) {
    return ranges.some(function (r) { return price >= r.min - 0.011 && price <= r.max; });
  }

  function buildParams(wrapper) {
    var params = new URLSearchParams(window.location.search);

    Array.from(params.keys()).forEach(function (key) {
      if (key.indexOf('filter.') === 0 || key === 'page' || key === 'section_id' || key === 'ccg_price') {
        params.delete(key);
      }
    });

    qsa(wrapper, '[data-ccg-filter-input]:checked').forEach(function (input) {
      if (input.name && input.value !== '') params.append(input.name, input.value);
    });

    var presets = checkedPresets(wrapper);
    if (presets.length) {
      var first = presets[0];
      var last = presets[presets.length - 1];
      var minParam = first.dataset.minParam || 'filter.v.price.gte';
      var maxParam = first.dataset.maxParam || 'filter.v.price.lte';
      // Native Shopify range = overall span of the selected presets.
      if (first.dataset.min !== '') params.set(minParam, first.dataset.min);
      if (last.dataset.max !== '') params.set(maxParam, last.dataset.max);
      // Non-neighbouring selection: remember exact ranges so gaps can be hidden.
      if (!isContiguous(wrapper)) {
        params.set('ccg_price', presets.map(function (p) { return p.dataset.key; }).join(','));
      }
    }

    var sort = qs(wrapper, '[data-ccg-sort]');
    if (sort && sort.value) params.set('sort_by', sort.value);
    return params;
  }

  function pendingCount(wrapper) {
    return qsa(wrapper, '[data-ccg-filter-input]:checked').length + checkedPresets(wrapper).length;
  }

  function updateBadge(wrapper) {
    var count = pendingCount(wrapper);
    qsa(wrapper, '[data-ccg-badge], [data-ccg-active-count]').forEach(function (badge) {
      badge.textContent = String(count);
      if (badge.hasAttribute('data-ccg-badge')) {
        if (count) badge.removeAttribute('hidden');
        else badge.setAttribute('hidden', '');
      }
    });
    var chips = qs(wrapper, '[data-ccg-chips]');
    if (chips) chips.classList.toggle('ccg-chips--empty', count === 0);

    var clearLink = qs(wrapper, '[data-ccg-top-clear]');
    if (count && !clearLink) {
      clearLink = document.createElement('a');
      clearLink.href = wrapper.getAttribute('data-collection-url') || window.location.pathname;
      clearLink.className = 'ccg-topbar__clear';
      clearLink.setAttribute('data-ccg-top-clear', '');
      clearLink.textContent = 'Clear all';
      var left = qs(wrapper, '.ccg-topbar__left');
      if (left) left.appendChild(clearLink);
    } else if (!count && clearLink) {
      clearLink.remove();
    }
  }

  function makeChip(text, removeType, param, value) {
    var chip = document.createElement('span');
    chip.className = 'ccg-chip';
    chip.setAttribute('data-ccg-pending-chip', '');
    if (param) chip.setAttribute('data-param', param);
    if (value != null) chip.setAttribute('data-value', value);
    var label = document.createElement('span');
    label.textContent = text;
    chip.appendChild(label);
    var button = document.createElement('button');
    button.type = 'button';
    button.setAttribute(removeType === 'price' ? 'data-ccg-chip-remove-price' : 'data-ccg-chip-remove', '');
    button.setAttribute('aria-label', 'Remove ' + text);
    button.innerHTML = '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="3" stroke-linecap="round"/></svg>';
    chip.appendChild(button);
    return chip;
  }

  function updateChips(wrapper) {
    var container = qs(wrapper, '[data-ccg-chips]');
    if (!container) return;
    container.innerHTML = '';

    qsa(wrapper, '[data-ccg-filter-input]:checked').forEach(function (input) {
      var label = input.closest('.ccg-check');
      var labelText = qs(label, '.ccg-check__label');
      container.appendChild(makeChip(labelText ? labelText.textContent.trim() : input.value, 'filter', input.name, input.value));
    });

    // One chip per selected price range.
    checkedPresets(wrapper).forEach(function (preset) {
      var parent = preset.closest('.ccg-check');
      var label = qs(parent, '.ccg-check__label');
      container.appendChild(makeChip(label ? label.textContent.trim() : 'Price', 'price', null, preset.dataset.key || ''));
    });
  }

  // ---------- Count preview (exact OR total) ----------

  function collectionUrlWithParams(wrapper, params) {
    var baseUrl = (wrapper && wrapper.getAttribute('data-collection-url')) || window.location.pathname;
    var url = new URL(baseUrl, window.location.origin);
    url.search = '';
    params.forEach(function (value, key) { url.searchParams.append(key, value); });
    return url.pathname + url.search + url.hash;
  }

  function fetchCount(wrapper, params) {
    var p = new URLSearchParams(params.toString());
    p.delete('ccg_price');
    var url = new URL(collectionUrlWithParams(wrapper, p), window.location.origin);
    url.searchParams.set('ccg_filter_count_preview', '1');
    return fetch(url.pathname + url.search, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to preview collection count');
      return response.text();
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var countEl = qs(doc, '[data-ccg-items-count]');
      if (!countEl) return 0;
      var match = countEl.textContent.match(/[\d,]+/);
      return match ? parseInt(match[0].replace(/,/g, ''), 10) : 0;
    });
  }

  // Contiguous / no price → one request. Non-contiguous → sum of each (disjoint) range.
  function totalCount(wrapper) {
    var base = buildParams(wrapper);
    var presets = checkedPresets(wrapper);
    if (!presets.length || isContiguous(wrapper)) return fetchCount(wrapper, base);

    var minParam = presets[0].dataset.minParam || 'filter.v.price.gte';
    var maxParam = presets[0].dataset.maxParam || 'filter.v.price.lte';
    return Promise.all(presets.map(function (p) {
      var pr = new URLSearchParams(base.toString());
      pr.delete(minParam);
      pr.delete(maxParam);
      if (p.dataset.min !== '') pr.set(minParam, p.dataset.min);
      if (p.dataset.max !== '') pr.set(maxParam, p.dataset.max);
      return fetchCount(wrapper, pr);
    })).then(function (counts) {
      return counts.reduce(function (a, b) { return a + b; }, 0);
    });
  }

  var previewRequests = new WeakMap();

  function updatePreview(wrapper) {
    var buttonCount = qs(wrapper, '[data-ccg-result-count]');
    if (!buttonCount) return;

    var requestId = (previewRequests.get(wrapper) || 0) + 1;
    previewRequests.set(wrapper, requestId);
    buttonCount.setAttribute('aria-busy', 'true');

    totalCount(wrapper).then(function (n) {
      if (previewRequests.get(wrapper) !== requestId) return;
      buttonCount.textContent = String(n);
    }).catch(function () {
      // Keep the last valid count if the preview request fails.
    }).finally(function () {
      if (previewRequests.get(wrapper) === requestId) {
        buttonCount.removeAttribute('aria-busy');
      }
    });
  }

  function updatePending(wrapper) {
    updateBadge(wrapper);
    updateChips(wrapper);
    updatePreview(wrapper);
  }

  // ---------- Non-contiguous price: hide products that sit in the gaps ----------

  var gapObservers = new WeakMap();

  function applyGapHiding(wrapper, ranges) {
    qsa(wrapper, '.product-grid__item[data-price]').forEach(function (li) {
      var price = parseFloat(li.getAttribute('data-price'));
      var show = !isFinite(price) || inRanges(price, ranges);
      li.style.display = show ? '' : 'none';
    });
  }

  function setupGapFilter(wrapper) {
    var raw = new URLSearchParams(window.location.search).get('ccg_price');
    if (!raw) return;

    var ranges = raw.split(',').map(function (key) {
      var parts = key.split('-');
      return {
        min: parts[0] === '' ? 0 : parseFloat(parts[0]),
        max: parts[1] === '' || parts[1] == null ? Infinity : parseFloat(parts[1])
      };
    });

    applyGapHiding(wrapper, ranges);

    if (!gapObservers.has(wrapper)) {
      var scheduled = false;
      var observer = new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () {
          scheduled = false;
          applyGapHiding(wrapper, ranges);
        });
      });
      observer.observe(wrapper, { childList: true, subtree: true });
      gapObservers.set(wrapper, observer);
    }

    // Show the real OR total in the top bar.
    totalCount(wrapper).then(function (n) {
      var el = qs(wrapper, '[data-ccg-items-count]');
      if (el) el.textContent = n + ' Items';
      var btn = qs(wrapper, '[data-ccg-result-count]');
      if (btn) btn.textContent = String(n);
    }).catch(function () {});
  }

  // ---------- Drawer ----------

  function lockPage() {
    document.documentElement.classList.add('ccg-filter-open');
    document.body.classList.add('ccg-filter-open');
  }
  function unlockPage() {
    document.documentElement.classList.remove('ccg-filter-open');
    document.body.classList.remove('ccg-filter-open');
  }

  var closeTimers = new WeakMap();
  var lastFocused = null;

  function openDrawer(wrapper) {
    var drawer = qs(wrapper, '[data-ccg-drawer]');
    var overlay = qs(wrapper, '[data-ccg-overlay]');
    if (!drawer) return;
    var timer = closeTimers.get(drawer);
    if (timer) clearTimeout(timer);
    lastFocused = document.activeElement;
    drawer.hidden = false;
    if (overlay) overlay.hidden = false;
    drawer.classList.remove('ccg-drawer--open');
    if (overlay) overlay.classList.remove('ccg-drawer-overlay--open');
    void drawer.offsetWidth;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        drawer.classList.add('ccg-drawer--open');
        if (overlay) overlay.classList.add('ccg-drawer-overlay--open');
      });
    });
    drawer.setAttribute('aria-hidden', 'false');
    var openButton = qs(wrapper, '[data-ccg-open-filters]');
    if (openButton) openButton.setAttribute('aria-expanded', 'true');
    lockPage();
    var closeBtn = qs(drawer, '[data-ccg-close-filters]');
    if (closeBtn) requestAnimationFrame(function () { closeBtn.focus({ preventScroll: true }); });
  }

  function closeDrawer(wrapper) {
    var drawer = qs(wrapper, '[data-ccg-drawer]');
    var overlay = qs(wrapper, '[data-ccg-overlay]');
    if (!drawer) {
      unlockPage();
      return;
    }
    drawer.classList.remove('ccg-drawer--open');
    if (overlay) overlay.classList.remove('ccg-drawer-overlay--open');
    drawer.setAttribute('aria-hidden', 'true');
    var openButton = qs(wrapper, '[data-ccg-open-filters]');
    if (openButton) openButton.setAttribute('aria-expanded', 'false');
    unlockPage();

    var timer = closeTimers.get(drawer);
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () {
      drawer.hidden = true;
      if (overlay) overlay.hidden = true;
      closeTimers.delete(drawer);
      if (lastFocused && document.contains(lastFocused)) lastFocused.focus({ preventScroll: true });
    }, 340);
    closeTimers.set(drawer, timer);
  }

  // Apply filters using a normal Shopify page load.
  function applyFilters(wrapper) {
    if (!wrapper) return;
    var params = buildParams(wrapper);
    window.location.assign(collectionUrlWithParams(wrapper, params));
  }

  // Clear every filter and pagination state, while preserving the selected sort order.
  function clearAllAndReload(wrapper) {
    if (!wrapper) return;
    var params = new URLSearchParams();
    var current = new URLSearchParams(window.location.search);
    var sortBy = current.get('sort_by');
    if (!sortBy) {
      var sort = qs(wrapper, '[data-ccg-sort]');
      if (sort && sort.value) sortBy = sort.value;
    }
    if (sortBy) params.set('sort_by', sortBy);
    window.location.assign(collectionUrlWithParams(wrapper, params));
  }

  function init(wrapper) {
    if (!wrapper) return;

    // Restore price preset checkboxes from the URL.
    var params = new URLSearchParams(window.location.search);
    var presets = allPresets(wrapper);
    if (presets.length) {
      var ccgPrice = params.get('ccg_price');
      var gte = params.get('filter.v.price.gte') || '';
      var lte = params.get('filter.v.price.lte') || '';

      if (ccgPrice) {
        var keys = ccgPrice.split(',');
        presets.forEach(function (p) { p.checked = keys.indexOf(p.dataset.key) !== -1; });
      } else if (gte !== '' || lte !== '') {
        var qMin = gte === '' ? -Infinity : parseFloat(gte);
        var qMax = lte === '' ? Infinity : parseFloat(lte);
        presets.forEach(function (p) {
          var r = presetRange(p);
          p.checked = r.min >= qMin - 0.011 && r.max <= qMax + 0.011;
        });
      } else {
        presets.forEach(function (p) { p.checked = false; });
      }
    }

    updateBadge(wrapper);
    updateChips(wrapper);
    setupGapFilter(wrapper);
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var open = target.closest('[data-ccg-open-filters]');
    if (open) { event.preventDefault(); openDrawer(wrapperFor(open)); return; }

    var close = target.closest('[data-ccg-close-filters]');
    if (close) { event.preventDefault(); closeDrawer(wrapperFor(close)); return; }

    var overlay = target.closest('[data-ccg-overlay]');
    if (overlay) { event.preventDefault(); closeDrawer(wrapperFor(overlay)); return; }

    var toggle = target.closest('[data-ccg-group-toggle]');
    if (toggle) {
      var group = toggle.closest('[data-ccg-group]');
      var body = qs(group, '.ccg-group__body');
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      if (body) body.hidden = expanded;
      return;
    }

    var remove = target.closest('[data-ccg-chip-remove], [data-ccg-chip-remove-price]');
    if (remove) {
      event.preventDefault();
      var chip = remove.closest('[data-ccg-chip], [data-ccg-pending-chip]');
      var wrapper = wrapperFor(remove);
      if (!wrapper) return;
      if (remove.hasAttribute('data-ccg-chip-remove-price')) {
        var key = chip ? chip.getAttribute('data-value') : '';
        allPresets(wrapper).forEach(function (input) {
          if (!key || input.dataset.key === key) input.checked = false;
        });
      } else if (chip) {
        var param = chip.getAttribute('data-param');
        var value = chip.getAttribute('data-value');
        qsa(wrapper, '[data-ccg-filter-input]').forEach(function (input) {
          if (input.name === param && input.value === value) input.checked = false;
        });
      }
      updatePending(wrapper);
      return;
    }

    var clear = target.closest('[data-ccg-clear-all-footer]');
    if (clear) { event.preventDefault(); clearAllAndReload(wrapperFor(clear)); return; }

    var apply = target.closest('[data-ccg-apply]');
    if (apply) {
      event.preventDefault();
      var applyWrapper = wrapperFor(apply);
      if (!applyWrapper) return;
      closeDrawer(applyWrapper);
      applyFilters(applyWrapper);
      return;
    }

    var topClear = target.closest('[data-ccg-top-clear]');
    if (topClear) {
      event.preventDefault();
      var topWrapper = wrapperFor(topClear);
      if (!topWrapper) return;
      clearAllAndReload(topWrapper);
    }
  });

  document.addEventListener('change', function (event) {
    var el = event.target;
    if (!el || !el.matches) return;
    var wrapper = wrapperFor(el);
    if (!wrapper) return;

    if (el.matches('[data-ccg-filter-input]') || el.matches('[data-ccg-price-preset]')) {
      updatePending(wrapper);
      return;
    }

    if (el.matches('[data-ccg-sort]')) {
      applyFilters(wrapper);
    }
  });

  window.addEventListener('pageshow', function () { unlockPage(); });
  document.addEventListener('shopify:section:load', function () {
    qsa(document, '.ccg').forEach(init);
    if (!qs(document, '.ccg-drawer.ccg-drawer--open')) unlockPage();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      qsa(document, '.ccg').forEach(init);
      unlockPage();
    });
  } else {
    qsa(document, '.ccg').forEach(init);
    unlockPage();
  }
})();